import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CompanyVoteProposalNameFormComponent } from '../company-vote-proposal-name-form/company-vote-proposal-name-form.component';
import { CompanyVoteProposalNameService } from '../../../services/company-vote-proposal-name.service';
import { CreateCompanyVoteProposalNameRequest } from '../../../models/api/createCompanyVoteProposalNameRequest';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HotToastService } from '@ngxpert/hot-toast';
import { Helpers } from '../../../utilities/helpers';

@Component({
  selector: 'app-company-vote-proposal-name-create',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CompanyVoteProposalNameFormComponent, NgxSpinnerModule],
  templateUrl: './company-vote-proposal-name-create.component.html',
  styleUrls: ['./company-vote-proposal-name-create.component.scss']
})
export class CompanyVoteProposalNameCreateComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private proposalNameService: CompanyVoteProposalNameService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private toast: HotToastService
  ) {
    const currentYear = Helpers.defaultMeasurementYear();

    this.form = this.fb.group({
      year: [currentYear, Validators.required],
      fullName: ['', Validators.required],
      address: [''],
      website: [''],
      email: [''],
      country: [''],
      category: [''],
      subcategory: [''],
      notes: ['']
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.spinnerService.show();

      const formValue = this.form.value;
      const request: CreateCompanyVoteProposalNameRequest = {
        year: parseInt(formValue.year),
        fullName: formValue.fullName,
        address: formValue.address || '',
        website: formValue.website || '',
        email: formValue.email || '',
        countryId: formValue.country?.id || formValue.country,
        categoryId: formValue.category?.id || formValue.category,
        subCategoryId: formValue.subcategory?.id || formValue.subcategory || '',
        notes: formValue.notes || ''
      };

      this.proposalNameService.create(request).subscribe({
        next: () => {
          this.spinnerService.hide();
          this.toast.success('Shareholder proposal name created successfully', {
            iconTheme: {
              primary: 'var(--mat-sys-primary)',
              secondary: '#FFF',
            }
          });
          this.router.navigate(['/voting-results/shareholder-proposal-names/list']);
        },
        error: (error: Error) => {
          this.spinnerService.hide();
          this.toast.error('Error creating shareholder proposal name', {
            iconTheme: {
              primary: 'var(--mat-sys-error)',
              secondary: '#FFF',
            }
          });
          console.error('Error creating shareholder proposal name:', error);
        }
      });
    }
  }

  onCancel() {
    this.router.navigate(['/voting-results/shareholder-proposal-names/list']);
  }
}
